<template>
  <div>
    <div
      class="base-not-found"
    >
      <div class="base-not-found__not-found-img">
        <ImageLazy
          :src="NotFound"
          alt="page-not-found.png"
        />
      </div>
      <span class="not-found-description"> Halaman yang Anda Cari Tidak Ditemukan</span>
      <Button 
        id="button-goto-home"
        text="ke Halaman Utama"
        @click="goToHomePage"
      />
    </div>
  </div>
</template>

<script>
import NotFound from "@/assets/merchant/merchant-not-active.svg"
import Button from "@/components/new-button/Button";
import ImageLazy from "@/components/ImageLazy/index.vue";

export default {
  name: "NotFound",
  components: {Button, ImageLazy},
  data() {
    return {
      NotFound,
      link: "https://play.google.com/store/apps/details?id=com.lionparcel.services.consumer&hl=in",
      isiOs: false,
      originalLink: document.URL
    }
  },
  created() {
    this.setOriginalLink()
  },
  methods: {
    setOriginalLink() {
      if (this.$route.query.invitedby) {
        this.originalLink = this.link
      }
    },
    goToHomePage() {
      this.$router.replace('/')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/style.scss";
.base-not-found {
  padding: 0 40px;
  height: 80vh;
  text-align: center;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;

  &__not-found-img {
    width: 224px;
    height: 190px;

    & ::v-deep .skeleton-box {
      width: 100%;
      height: 100%;
    }
  }
}

#button-mobile {
  display: none;
}

#button-desktop {
  display: block;
}

#button-goto-home {
  margin-top: 21px;

  @include for-size(mobile) {
    width: 100%;
  }
}

.not-found-description {
  margin-top: 2%;
  color: $color-base-text;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
}

@media (max-width: 768px) {
  #button-mobile {
    display: block;
  }

  #button-desktop {
    display: none;
  }
}
</style>
